import React, {useEffect, useState} from 'react';
import cs from 'classnames';

import {publish} from '@stubhub/pubsub-utils';

import Alert from '../../modules/common/react-alert';
import Profile from '../../modules/profile/react-profile';
import {MYACCOUNT_EVENTS} from '../../tracking/track-enum';
import TrackListener from '../../tracking/track-listener';
import Navigation from '../react-navigation';

import './index.scss';

const MainLayout = ({hideSideLayout, children, className}) => {
  const [pageTitle, setPageTitle] = useState('');
  useEffect(() => {
    publish(MYACCOUNT_EVENTS.LOADED);
  }, []);

  const populateActiveNavItem = (activeNavItem) => {
    setPageTitle(activeNavItem);
  };

  return (
    <div id="app-container" className={cs('MyAccount__Layout', className)}>
      {!hideSideLayout && (
        <div className="MyAccount__Side">
          <div className="MyAccount__Profile">
            <Profile />
          </div>
          <div className="MyAccount__NavContainer">
            <Navigation populateActiveNavItem={populateActiveNavItem} />
          </div>
        </div>
      )}
      <div className="MyAccount__Main">
        <div className="MyAccount__title">{pageTitle}</div>
        <div className="MyAccount__body">{children}</div>
      </div>
      <Alert />
      <TrackListener />
    </div>
  );
};

export default MainLayout;
